function getGraphQlImageStatic(imageObj) {
  if (imageObj && imageObj.localFile && imageObj.localFile.publicURL) {
    return imageObj.localFile.publicURL;
  }

  return null;
}

export default getGraphQlImageStatic;
